﻿import React, { useCallback } from 'react';
import { Icon_Close } from '@Elements/ImageElements/Icons';

import { Close_Button_Props } from '@Util/Types';

const Close_Button: React.FC<Close_Button_Props> = (props) => {
    const handleClick = useCallback(() => {
        props.set_open(false);
        if (props.on_close_action) {
            props.on_close_action();
        }
    }, [props.set_open, props.on_close_action]);

    return (
        <button
            type="button"
            className="Popup_Button_Close"
            onClick={handleClick}
        >
            <Icon_Close />
        </button>
    );
};

export default Close_Button;